import { combineReducers } from 'redux';

import employeePermissionReducer from './permission';
import employeeListReducer from './list';
import employeeStaffReducer from './staff';
import employeePinReducer from './pin';
import roleReducer from './role';

export default combineReducers({
  permission: employeePermissionReducer,
  list: employeeListReducer,
  staff: employeeStaffReducer,
  pin: employeePinReducer,
  role: roleReducer,
});
